import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=014580d8&scoped=true&"
import script from "./UserStats.vue?vue&type=script&lang=js&"
export * from "./UserStats.vue?vue&type=script&lang=js&"
import style0 from "./UserStats.vue?vue&type=style&index=0&id=014580d8&scoped=true&lang=css&"
import style1 from "./UserStats.vue?vue&type=style&index=1&id=014580d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014580d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBtn,VCard,VCardText,VChip,VListItem,VListItemAction,VListItemContent,VListItemTitle,VProgressCircular,VVirtualScroll})
